// Guía "Cómo usar el guardarropa". Toma de GuiaCajasTPV.jsx el estilo y las partes
// compartidas (tip de puestos y funcionamiento de la grilla), así un cambio ahí
// llega a las dos guías.
import { STYLE, TIP_PUESTOS, GUARDARROPA_FUNCIONA } from './GuiaCajasTPV';

const HTML = `
<div style="min-height:100vh;background:#0A0A0B">

  <!-- NAV -->
  <header style="position:sticky;top:0;z-index:50;backdrop-filter:blur(18px);background:rgba(10,10,11,0.72);border-bottom:1px solid rgba(255,255,255,0.07)">
    <div style="max-width:1200px;margin:0 auto;padding:16px clamp(20px,5vw,64px);display:flex;align-items:center;justify-content:space-between;gap:16px">
      <a href="/ayuda" style="display:flex;align-items:center;gap:12px"><img src="/assets/guia/tukipro-logo.svg" alt="TUKIPRO" style="height:22px;display:block"></a>
      <a href="/ayuda" style="font-family:'Pixelify Sans',sans-serif;font-size:13px;letter-spacing:.1em;color:#7a7a82">CENTRO DE AYUDA</a>
    </div>
  </header>

  <div style="max-width:1200px;margin:0 auto;padding:clamp(28px,5vw,56px) clamp(20px,5vw,64px)">

    <main style="max-width:820px;margin:0 auto">
      <a href="/ayuda" style="display:inline-block;font-size:13px;color:#7a7a82;margin-bottom:22px">← Volver al centro de ayuda</a>
      <p style="font-family:'Pixelify Sans',sans-serif;font-size:12px;letter-spacing:.22em;color:#EC268F;margin:0 0 14px">— GUÍA —</p>
      <h1 style="font-family:'Pixelify Sans',sans-serif;font-weight:600;font-size:clamp(30px,5vw,52px);line-height:1.05;margin:0 0 20px">Cómo usar el guardarropa</h1>
      <p style="font-size:17px;color:#A0A0A8;line-height:1.6;max-width:60ch;margin:0 0 clamp(40px,6vw,64px)">El guardarropa se cobra desde una <strong style="color:#fff">caja TPV</strong>, igual que la barra. Cada prenda queda asignada a un número de percha y el sistema imprime un ticket para el cliente y otro para colgar con la prenda, así nada se mezcla y al final de la noche sabés qué quedó sin retirar.</p>

      <!-- PASO 1 -->
      <section class="paso">
        <div class="paso-head"><span class="paso-num">1</span><h2>Crear el menú de guardarropa</h2></div>
        <p class="txt">En la administración del venue, entrá a <strong>Cajas TPV</strong>, tocá <strong>+ Crear menú</strong> y elegí el tipo <strong>Guardarropa</strong>. Cargá los productos que vas a cobrar, por ejemplo <em>Prenda general</em> con su precio. Lo creás una sola vez y lo usás en todos tus eventos.</p>
        <div class="caja"><p><strong>Conviene cargar los productos con precio:</strong> así el cajero cobra el precio fijo y no puede modificarlo. Si el menú queda sin productos, el cajero tiene que escribir el precio a mano en cada cobro.</p></div>
      </section>

      <!-- PASO 2 -->
      <section class="paso">
        <div class="paso-head"><span class="paso-num">2</span><h2>Crear la caja del guardarropa en el evento</h2></div>
        <p class="txt">Entrá al evento, abrí la pestaña <strong>Cajas</strong> y tocá <strong>+ Nueva caja</strong>. Completá el <strong>nombre</strong> (por ejemplo, Guardarropa), el <strong>PIN</strong> de 4 dígitos que va a usar el cajero y elegí el <strong>menú de guardarropa</strong>. Después definí sus <strong>perchas</strong> con un rango <strong>Desde / Hasta</strong> (por ejemplo, del 1 al 200): esos son los números que vas a ver en la grilla.</p>
        <div class="img"><img src="/assets/guia/guia-13-cajas-evento-ejemplo.webp" alt="Pestaña Cajas del evento: formulario de nueva caja"></div>
${TIP_PUESTOS}
      </section>

      <!-- PASO 3 -->
      <section class="paso">
        <div class="paso-head"><span class="paso-num">3</span><h2>Abrir la caja en la noche</h2></div>
        <p class="txt">En la tablet con la app TPV de TukiPro instalada, iniciá sesión con la cuenta de tu boliche, elegí el <strong>evento</strong> y la <strong>caja</strong> del guardarropa, ingresá el <strong>PIN</strong> y tocá <strong>Abrir caja</strong>.</p>
        <div class="img img--angosta"><img src="/assets/guia/guia-14-acceso-tpv-ejemplo.webp" alt="Pantalla de acceso al TPV: evento, caja y PIN"></div>
      </section>

      <!-- PASO 4 -->
      <section class="paso" style="margin-bottom:clamp(24px,4vw,32px)">
        <div class="paso-head"><span class="paso-num">4</span><h2>Cómo funciona el guardarropa</h2></div>
${GUARDARROPA_FUNCIONA}
      </section>

      <!-- TENÉ EN CUENTA -->
      <div class="caja" style="padding:clamp(22px,4vw,30px);margin-top:clamp(40px,6vw,56px)">
        <p style="font-family:'Pixelify Sans',sans-serif;font-size:17px;color:#fff;margin:0 0 16px">Tené en cuenta</p>
        <ul class="lista" style="margin:0">
          <li><span class="dot">·</span><span><strong>Probá la impresora antes de abrir.</strong> Desde la caja podés vincular la impresora Bluetooth y hacer una impresión de prueba. Mejor descubrir un problema antes de que llegue la gente.</span></li>
          <li><span class="dot">·</span><span><strong>Funciona sin internet.</strong> Si se corta la conexión, la caja sigue cobrando e imprimiendo, y las ventas se sincronizan solas cuando vuelve la señal.</span></li>
          <li><span class="dot">·</span><span><strong>Lo cobrado lo ves en Venta de artículos</strong>, dentro de la pestaña Cajas del evento, junto con el resto de las cajas.</span></li>
        </ul>
      </div>

      <!-- CIERRE -->
      <div style="border:1px solid rgba(236,38,143,0.4);background:rgba(236,38,143,0.06);padding:clamp(24px,4vw,34px);display:flex;flex-wrap:wrap;gap:20px;align-items:center;justify-content:space-between;margin-top:clamp(28px,4vw,40px)">
        <div>
          <p style="font-family:'Pixelify Sans',sans-serif;font-size:17px;margin:0 0 6px">¿Vas a armar también las barras y la boletería?</p>
          <p style="font-size:14px;color:#A0A0A8;margin:0">Mirá la guía completa de <a href="/ayuda/cajas-tpv" style="color:#FF9DCD;font-weight:600;text-decoration:underline">Cajas TPV →</a></p>
        </div>
        <a href="/ayuda" style="font-family:'Pixelify Sans',sans-serif;font-weight:600;font-size:15px;padding:14px 26px;border-radius:999px;background:#EC268F;color:#fff;white-space:nowrap">Volver al centro de ayuda</a>
      </div>
    </main>
  </div>
</div>`;

export default function GuiaGuardarropa() {
  return (
    <div className="tkp-guia">
      <style>{STYLE}</style>
      <div dangerouslySetInnerHTML={{ __html: HTML }} />
    </div>
  );
}
